// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CheckoutPage_checkoutPage__TeYef {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.CheckoutPage_summaryContainer__SGKiW {
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: center;
  align-items: flex-start;
  flex: 1 1;
  margin-top: 20px;
  padding: 20px;
}

.CheckoutPage_highlight__VEk9c {
  color: #cfb277;
}

.CheckoutPage_formTitle__X7-kv {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 32px;
  line-height: 1.4;
  text-align: center;

}

.CheckoutPage_divider__AFM-t {
  display: none;
}

.CheckoutPage_proceedButtonContainer__5-1wA {
  display: none;
}



@media (max-width: 480px) {
  .CheckoutPage_summaryContainer__SGKiW {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
  .CheckoutPage_formTitle__X7-kv {
    display: none;
  }

  .CheckoutPage_proceedButtonContainer__5-1wA {
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 8px 20px;
    gap: 8px;
    position: sticky;
    bottom: 0;
    background-color: #ffffff;
    z-index: 1000;
  }

  .CheckoutPage_divider__AFM-t {
    display: block;
    width: 100%;
    height: 1px;
    background-color: #e0e0e0;
  }


}

@media (min-width: 481px) and (max-width: 1024px) {
  .CheckoutPage_formTitle__X7-kv {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/CheckoutPage/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;;AAEpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;;;AAIA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;IAChB,SAAS;IACT,yBAAyB;IACzB,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B;;;AAGF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".checkoutPage {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.summaryContainer {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  justify-content: center;\n  align-items: flex-start;\n  flex: 1;\n  margin-top: 20px;\n  padding: 20px;\n}\n\n.highlight {\n  color: #cfb277;\n}\n\n.formTitle {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 32px;\n  line-height: 1.4;\n  text-align: center;\n\n}\n\n.divider {\n  display: none;\n}\n\n.proceedButtonContainer {\n  display: none;\n}\n\n\n\n@media (max-width: 480px) {\n  .summaryContainer {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n  .formTitle {\n    display: none;\n  }\n\n  .proceedButtonContainer {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    padding: 8px 20px;\n    gap: 8px;\n    position: sticky;\n    bottom: 0;\n    background-color: #ffffff;\n    z-index: 1000;\n  }\n\n  .divider {\n    display: block;\n    width: 100%;\n    height: 1px;\n    background-color: #e0e0e0;\n  }\n\n\n}\n\n@media (min-width: 481px) and (max-width: 1024px) {\n  .formTitle {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"checkoutPage": `CheckoutPage_checkoutPage__TeYef`,
	"summaryContainer": `CheckoutPage_summaryContainer__SGKiW`,
	"highlight": `CheckoutPage_highlight__VEk9c`,
	"formTitle": `CheckoutPage_formTitle__X7-kv`,
	"divider": `CheckoutPage_divider__AFM-t`,
	"proceedButtonContainer": `CheckoutPage_proceedButtonContainer__5-1wA`
};
export default ___CSS_LOADER_EXPORT___;
